export default {
  path: 'robot_notify',
  name: 'demo_robot_notify',
  component: () => import('@/pages/demo/notify/robotSend/index.vue'),
  meta: {title: '功能示例-机器消息通知'},
}
